import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Lets a shopper pick a quantity "tier" (Individual / Dúo / Pack de Ahorro, etc.)
 * and syncs the selection with the page's native quantity-selector-component,
 * so "Agregar al carrito" adds the right quantity and Shopify's own quantity
 * price breaks apply the correct discounted price automatically.
 */
class QuantityTierSelector extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.handleTierChange);
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.handleExternalQuantityChange);

    // The pre-checked tier (server-rendered, may be Dúo/Tripack rather than
    // Individual) needs to push its quantity into the real add-to-cart
    // quantity selector on load too - otherwise a shopper who never
    // interacts with these radios (they already look selected) would still
    // add just 1 unit despite a non-Individual tier appearing chosen.
    const checkedInput = this.querySelector('input[type="radio"]:checked');
    if (checkedInput instanceof HTMLInputElement) {
      const quantity = Number(checkedInput.dataset.quantity);
      if (quantity) this.syncQuantitySelector(quantity);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.handleExternalQuantityChange);
  }

  /**
   * @param {number} quantity
   */
  syncQuantitySelector = (quantity) => {
    const quantitySelector = document.querySelector('quantity-selector-component');
    if (!quantitySelector) return;

    quantitySelector.setValue(quantity.toString());
    quantitySelector.onQuantityChange();
    quantitySelector.updateButtonStates();
  };

  /**
   * @param {Event} event
   */
  handleTierChange = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;

    const quantity = Number(event.target.dataset.quantity);
    if (!quantity) return;

    this.syncQuantitySelector(quantity);
  };

  /**
   * Keeps the tier cards in sync when the shopper uses the native +/- stepper
   * directly instead of clicking a tier.
   * @param {CustomEvent<{quantity: number}>} event
   */
  handleExternalQuantityChange = (event) => {
    const quantity = event.detail?.quantity;
    if (!quantity) return;

    const matchingInput = this.querySelector(`input[data-quantity="${quantity}"]`);
    if (matchingInput instanceof HTMLInputElement) {
      matchingInput.checked = true;
    }
  };
}

if (!customElements.get('quantity-tier-selector')) {
  customElements.define('quantity-tier-selector', QuantityTierSelector);
}
